import { UrlReqError } from 'types/url-req-error';

// reqErrors that enable a fill manually option to be displayed upon error
export const fillManuallyReqErrors = new Set([
  UrlReqError.Timeout,
  UrlReqError.External,
  UrlReqError.PdfParsingError,
]);
